// Per-device local state for likes and saves — no auth required.
// Likes are write-once per device (prevents the same browser from inflating counters).
// Saves are togglable per device and shown on the /saved page.

const LIKES_KEY = 'ardnotes:likes';
const SAVES_KEY = 'ardnotes:saves';

const readSet = (key) => {
  try {
    const raw = localStorage.getItem(key);
    return new Set(raw ? JSON.parse(raw) : []);
  } catch {
    return new Set();
  }
};

const writeSet = (key, set) => {
  try {
    localStorage.setItem(key, JSON.stringify(Array.from(set)));
  } catch {
    // localStorage disabled (private mode, etc.) — silently ignore
  }
};

export const hasLocalLike = (resourceId) => readSet(LIKES_KEY).has(resourceId);

export const addLocalLike = (resourceId) => {
  const s = readSet(LIKES_KEY);
  s.add(resourceId);
  writeSet(LIKES_KEY, s);
};

export const hasLocalSave = (resourceId) => readSet(SAVES_KEY).has(resourceId);

export const toggleLocalSave = (resourceId) => {
  const s = readSet(SAVES_KEY);
  if (s.has(resourceId)) {
    s.delete(resourceId);
    writeSet(SAVES_KEY, s);
    return false;
  }
  s.add(resourceId);
  writeSet(SAVES_KEY, s);
  return true;
};

export const getAllLocalSaves = () => Array.from(readSet(SAVES_KEY));
